<!--suppress HtmlUnknownTag-->
<template>
  <v-list-item @click="openAndAwaitWindow">
    <v-list-item-icon>
      <v-icon>{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-title>{{ text }}</v-list-item-title>
  </v-list-item>
</template>

<script>
  import cookies from 'vue-cookies';

  function trustMessageOrigin (origin, localDevelopmentPort) {
    return origin === 'https://teonistor.herokuapp.com'
        || origin === 'http://localhost:' + localDevelopmentPort
        || origin === 'http://' + location.hostname + ':' + localDevelopmentPort;
  }

  function receiveMessage (event, localDevelopmentPort) {
    if (!trustMessageOrigin(event.origin, localDevelopmentPort)) {
      console.log('Discarded message due to unexpected origin ' + event.origin);
      return false;
    }

    try {
      const ev = JSON.parse(event.data);

      if (ev.delete)
        cookies.remove('Authorization');

      if (ev.put)
        // On further thought, local storage is most suited to this use case
        // keyName, value[, expires[, path[, domain[, secure[, sameSite]]]]]
        cookies.set('Authorization', ev.put, 0, undefined, undefined, false, 'Strict');

      return true;

    } catch (e) {
      console.warn('Could not parse event JSON, falling back to v1...', e)

    const parse = event.data.match(/([^:]+):(.*)/);
    if (!parse) {
      console.log('Discarded malformed message');
      return false;
    }

    if (parse[1] === 'Auth-Set') {
      // On further thought, local storage is most suited to this use case
      // keyName, value[, expires[, path[, domain[, secure[, sameSite]]]]]
      cookies.set('Authorization', parse[2], 0, undefined, undefined, false, 'Strict');
      return true;
    }

    if (parse[1] === 'Auth-Unset') {
      cookies.remove('Authorization');
      return true;
    }

    console.log('Discarded message due to unexpected key ' + parse[1]);
   }
  }

  function onSuccessfulMessage(popup) {
    popup.close();
    window.location.reload();
  }

  export default {
    name: 'PopupTrigger',

    props: ['absolutePath', 'pathFromBackend', 'icon', 'text'],

    computed: {
      effectivePath () {
        return this.absolutePath
            || this.$backendRoot + this.pathFromBackend;
      }
    },

    methods: {
      openAndAwaitWindow () {
        const popup = this.popupWindow(500, 750);

        window.addEventListener('message',
          event => receiveMessage(event, this.$localDevelopmentPort)
                && onSuccessfulMessage(popup),
          { once: true });
      },

      popupWindow(w, h) {
        const x = window.top.outerWidth / 2 + window.top.screenX - (w / 2);
        const y = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
        const u = `popup, width=${w}, height=${h}, left=${x}, top=${y}`;
        return window.open(this.effectivePath, null, u);
      }
    }
  }
</script>
